<!-- Individual Question -->
<section class="container">
    <div class="card border-dark">

        <!-- Question -->
        <div class="card-header">
            <h1 class="bolder">Question {{questionNumber + 1}}:</h1>
            <p class="bold question">{{question.question}}</p>
        </div>

        <!-- Form -->
        <form [formGroup]="form">

            <!-- Show Each Question Todo: Make it one question at a time -->
            <div class="card-body">
                <div *ngFor="let option of question.answers; let i = index;" class="radio-item">
                    <input type="radio" [value]="i" formControlName="choice" [id]="'qf_' + (questionNumber + 1) + '_' + i + salt">
                    <label [for]="'qf_' + (questionNumber + 1) + '_' + i + salt">
                      <span class="bold ml-2 mr-1">{{letterArray[i]}}.</span>
                      <span>{{option}}</span>
                    </label>
                </div>
            </div>
        </form>
    </div>
</section>
